export const ProjectNameTitle = ({ desc, job }) => {
  return (
    <div>
      <h2>{desc}</h2>
      <h3>{job}</h3>
    </div>
  );
};
